import { WhatsappLogo } from '@phosphor-icons/react';

const getWhatsAppUrl = (number, message) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const encoded = encodeURIComponent(message);
  return isMobile
    ? `https://wa.me/${number}?text=${encoded}`
    : `https://web.whatsapp.com/send?phone=${number}&text=${encoded}`;
};

const WhatsAppButton = () => {
  const whatsappNumber = (process.env.REACT_APP_WHATSAPP_NUMBER || '917416970039');
  const message = 'Hi, I have a question about Posterly posters!';

  const handleClick = (e) => {
    e.preventDefault();
    window.open(getWhatsAppUrl(whatsappNumber, message), '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#1fb855] text-white p-4 rounded-full shadow-lg transition-all hover:scale-110"
      data-testid="whatsapp-button"
      aria-label="Contact us on WhatsApp"
    >
      <WhatsappLogo size={28} weight="fill" />
    </button>
  );
};

export { getWhatsAppUrl };
export default WhatsAppButton;
